/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_News_Meta_DescriptionInputs */

const ja_playdata_news_meta_description = /** @type {(inputs: Playdata_News_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATAのニュースとレポートのリリース情報。`)
};

const en_playdata_news_meta_description = /** @type {(inputs: Playdata_News_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`News and report releases from PLAYDATA.`)
};

/**
* | output |
* | --- |
* | "News and report releases from PLAYDATA." |
*
* @param {Playdata_News_Meta_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_news_meta_description = /** @type {((inputs?: Playdata_News_Meta_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_News_Meta_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_news_meta_description(inputs)
	return en_playdata_news_meta_description(inputs)
});